import React, { useState } from "react";
import { FaSearch } from "react-icons/fa";
import "./CategoryDropdown.css";
import { useNavigate } from "react-router-dom";

type CategoryOption = {
  title: string;
};

const CsearchCategories: CategoryOption[] = [

  { title: "All Categories" },
  { title: "Cooking Materials" },
  { title: "Beverages Mix & Snacks" },
  { title: "Personal Care" },
  { title: "House Hold Care & Cleanings" },
];

const CategoryDropdown: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(CsearchCategories[0]);
  const navigate = useNavigate()

  const toggleDropdown = () => setIsOpen((prev) => !prev);
  const handleSelect = (option: CategoryOption) => {
    setSelected(option);
    setIsOpen(false);
    navigate(`/special?category=${encodeURIComponent(option.title)}`);

  };

  return (
    <div className="category-dropdown">
      <div className="category-dropdown-selected" onClick={toggleDropdown}>
        <FaSearch className="search-icon" />
        <span>{selected.title}</span>
        <span className="arrow">{isOpen ? "▲" : "▼"}</span>
      </div>

      {isOpen && (
        <div className="category-dropdown-options">
          {CsearchCategories.map((option) => (
            <div
              key={option.title}
              className="category-dropdown-option"
              onClick={() => handleSelect(option)}
            >
              {option.title}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CategoryDropdown;
